export type StatKind = "archive" | "dossier";

export type StatItem = {
  id: string;
  kind: StatKind;
  label: string;
  value: string;
  numeric?: number;
  suffix?: string;
  note?: string;
};

export const archiveStats: StatItem[] = [
  {
    id: "contract",
    kind: "archive",
    label: "SIG contract",
    value: "4,000",
    numeric: 4000,
    note: "Rifles ordered from Neuhausen, 1908.",
  },
  {
    id: "mexico",
    kind: "archive",
    label: "Reached Mexico",
    value: "40–1,000",
    note: "Estimations and sources vary.",
  },
  {
    id: "mass",
    kind: "archive",
    label: "Mass",
    value: "4.18",
    numeric: 4.18,
    suffix: "kg",
  },
  {
    id: "length",
    kind: "archive",
    label: "Length",
    value: "1,105",
    numeric: 1105,
    suffix: "mm",
  },
  {
    id: "barrel",
    kind: "archive",
    label: "Barrel",
    value: "577",
    numeric: 577,
    suffix: "mm",
  },
  {
    id: "mv",
    kind: "archive",
    label: "Muzzle velocity",
    value: "760",
    numeric: 760,
    suffix: "m/s",
  },
  {
    id: "range",
    kind: "archive",
    label: "Effective range",
    value: "800",
    numeric: 800,
    suffix: "m",
  },
  {
    id: "caliber",
    kind: "archive",
    label: "Cartridge",
    value: "7×57mm Mauser",
  },
  {
    id: "action",
    kind: "archive",
    label: "Action",
    value: "Gas, rotating bolt",
  },
  {
    id: "feed",
    kind: "archive",
    label: "Feed",
    value: "10-rd mag",
    note: "Loaded by 5-rd stripper clips. German flyers: 30-rd Blum drum.",
  },
  {
    id: "maker",
    kind: "archive",
    label: "Manufacturer",
    value: "SIG Neuhausen",
  },
  {
    id: "cost",
    kind: "archive",
    label: "Unit cost",
    value: "SFr 160",
  },
];

export const dossierStats: StatItem[] = [
  {
    id: "nick",
    kind: "dossier",
    label: "Nickname",
    value: "El Demonia",
    note: "The name Griffin Dolls use for her — carefully.",
  },
  {
    id: "index",
    kind: "dossier",
    label: "Index",
    value: "317",
    numeric: 317,
  },
  {
    id: "rarity",
    kind: "dossier",
    label: "Rarity / type",
    value: "4★ RF",
  },
  {
    id: "faction",
    kind: "dossier",
    label: "Faction",
    value: "Griffin & Kryuger",
  },
  {
    id: "iop",
    kind: "dossier",
    label: "Manufactured / revised by",
    value: "I.O.P.",
  },
  {
    id: "artist",
    kind: "dossier",
    label: "Artist",
    value: "電報N",
  },
  {
    id: "va",
    kind: "dossier",
    label: "Voice",
    value: "Togashi Misuzu",
  },
  {
    id: "release",
    kind: "dossier",
    label: "Released",
    value: "CN 2020.8",
  },
  {
    id: "acq",
    kind: "dossier",
    label: "Acquisition",
    value: "Dual Randomness Ch.2 Drop",
  },
  {
    id: "hp",
    kind: "dossier",
    label: "HP (x1 max)",
    value: "84",
    numeric: 84,
  },
  {
    id: "dmg",
    kind: "dossier",
    label: "Damage",
    value: "112",
    numeric: 112,
  },
  {
    id: "acc",
    kind: "dossier",
    label: "Accuracy",
    value: "74",
    numeric: 74,
  },
  {
    id: "eva",
    kind: "dossier",
    label: "Evasion",
    value: "34",
    numeric: 34,
  },
  {
    id: "rof",
    kind: "dossier",
    label: "Rate of fire",
    value: "41",
    numeric: 41,
  },
  {
    id: "crit",
    kind: "dossier",
    label: "Crit rate",
    value: "40",
    numeric: 40,
    suffix: "%",
  },
];

export const skill = {
  name: "Conviction of Certain Victory",
  initial: 5,
  cooldownLv10: 16,
  tiles: {
    affect: "Affects rifles",
    bonus: "Increases damage by 15%",
    cells: ["empty", "buff", "empty", "empty", "self", "empty", "empty", "buff", "empty"] as const,
  },
  text: [
    "[Passive]: If currently assigned as an echelons leader, permanently reduces own rate of fire by 35% while increasing allied Rifles' critical hit rate by 20% and critical hit damage by 10%.",
    "[Active]: When skill is activated, allies on her tiles gain 15% damage and 12% rate of fire for 5 seconds.",
    "[EQ Passive]: When equipped with \"Old Camouflage Uniform\", does not reduce own rate of fire when assigned as the echelons leader.",
  ],
};

export const personality =
  "Rational and serious, she has a wealth of combat experience and prioritizes rules and regulations. She knows the flaws of most Dolls like the back of her hand, and eagerly seeks to correct Dolls' faults in combat. She even resorts to extremely harsh methods in order to achieve her aim. Today, she — known to Griffin Dolls as \"El Demonia\" — is on patrol…";
